
import React from 'react';
import { Lock, ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const LandingFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2563EB] text-white py-8 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Lock className="h-5 w-5" />
          <p 
            className="text-base font-medium"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            Tus datos están protegidos.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4">
          <p 
            className="text-sm opacity-90"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            Consulta nuestra{' '}
            <Link 
              to="/privacy-policy" 
              className="underline hover:no-underline transition-all duration-200"
            >
              política de privacidad
            </Link>
            .
          </p>
          
          <Button
            onClick={scrollToTop}
            variant="ghost"
            size="sm"
            className="text-white hover:bg-white/10 flex items-center gap-2 transition-all duration-200"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            <ArrowUp className="h-4 w-4" />
            Inicio
          </Button>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
